<div class="title">
  <div class="heading">
    <span>{{ 'SCHEDULE_BOT.JOIN_MEETING_V2' | translate }}</span>
  </div>
  <div class="settings">
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
<div class="atlas-navbar__container">
  <div class="container">
    <p>{{ 'SCHEDULE_BOT.DESCRIPTION_V2' | translate }}</p>
    <div class="action-container">
      <glxy-form-field bottomSpacing="none" class="grow">
        <glxy-label>{{ 'SCHEDULE_BOT.MEETING_URL' | translate }}</glxy-label>
        <glxy-label-hint>{{ 'SCHEDULE_BOT.INPUT_HINT' | translate }}</glxy-label-hint>
        <input
          [placeholder]="'SCHEDULE_BOT.PLACEHOLDER' | translate"
          type="text"
          matInput
          [formControl]="formControl"
        />
        @if ((formControl.dirty || formControl.touched) && (invalidUrl$ | async)) {
            <glxy-error>
              {{ 'SCHEDULE_BOT.URL_INVALID' | translate }}
            </glxy-error>
        }
      </glxy-form-field>
        <button mat-raised-button color="primary" (click)="joinMeeting()" [disabled]="(invalidUrl$ | async) || (isUrlEmpty$ | async)">
        {{ 'SCHEDULE_BOT.SEND_NOW' | translate }}
      </button>
    </div>
  </div>
</div>
